import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { ApiService } from '../../services/index';
import { CreateScenarioDto, Scenario } from '../../types/scenario-modeling.types';
import { useIdempotentAppMutation } from '../use-idempotent-app-mutation.hook';

export const useCreate = () => {
  const { mutate: create, isPending } = useIdempotentAppMutation<
    Scenario,
    HttpException,
    { data: CreateScenarioDto }
  >([QueryKey.CREATE_SCENARIO], {
    mutationFn: ({ data }: { data: CreateScenarioDto }, { headers }) =>
      ApiService.post({ endpoint: BackendRoute.SCENARIOS }, { body: data, headers }),
  });
  return { create, isPending };
};
